import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'redux';
import { Link } from 'react-router-dom';

import Button from 'components/deprecated/legacyElements/Button';
import Spinner from 'components/Spinner';
import H1 from 'components/deprecated/legacyElements/H1';
import withUser from 'components/withUser';
import Redirect from 'components/Redirect';
import passwordRecoveryEmailMutation from 'queries/mutations/PasswordRecoveryEmailMutation.gql';

import styles from './style.module.scss';

class ForgotPasswordPage extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.any,
    error: PropTypes.any,
    loading: PropTypes.bool,
    sendEmail: PropTypes.func.isRequired,
  };

  static defaultProps = {
    currentUser: undefined,
    error: null,
    loading: false,
  };

  state = {
    email: '',
    completed: false,
    errored: false,
  };

  onInputChange = (evt) => this.setState({ email: evt.currentTarget.value });

  onSubmit = (evt) => {
    evt.preventDefault();

    this.props
      .sendEmail({
        variables: {
          email: this.state.email,
        },
      })
      .then(() => this.setState({ completed: true }))
      .catch(() => this.setState({ errored: true }));
  };

  render() {
    if (this.props.currentUser) return <Redirect push to="/" />;
    return (
      <div className={styles.container}>
        <Helmet title="Reset Your Password" />
        <form onSubmit={this.onSubmit}>
          <H1>Forgot your password?</H1>
          <p>Enter your email to reset your password.</p>
          <input
            name="email"
            type="email"
            placeholder="Email"
            required
            onChange={this.onInputChange}
            value={this.state.email}
          />
          <Button type="submit">Email me reset instructions</Button>
        </form>
        {this.props.loading && <Spinner />}
        {(this.props.error || this.state.errored) && (
          <p>
            There was a problem resetting your password, please try again later.
          </p>
        )}
        {this.state.completed && (
          <p>
            Please check your email for instructions to finish resetting your
            password.
          </p>
        )}
        <Link to="/profile/size">Don&rsquo;t have an account?</Link>
      </div>
    );
  }
}

export default compose(
  withUser,
  graphql(passwordRecoveryEmailMutation, { name: 'sendEmail' })
)(ForgotPasswordPage);
